import React from 'react';


function HypoTypeBlock({title, text, active, handleHypoChange}) {

    return (
        <div
            className={`ct-step__hypo-type-block ${active ? 'ct-step__hypo-type-block-active' : null}`}
            onClick={() => handleHypoChange(title === 'Annuïteiten')}
        >
            <div>
                {title}
            </div>
            <div>
                {text}
            </div>
        </div>
    );
}

export default HypoTypeBlock;
